<nav aria-label="breadcrumb">
  <div class="container">
    <ol class="breadcrumb">
      @for (breadcrumb of breadcrumbs; track breadcrumb) {
        <li class="breadcrumb-item"
          [ngClass]="breadcrumb.url === '#' ? 'active' : ''">
          @if (breadcrumb.url !== '#') {
            <a [href]="breadcrumb.url" (click)="gotoUrl($event, breadcrumb.url)"
            [innerHTML]="breadcrumb.title|translate"></a>
          }
          @if (breadcrumb.url === '#') {
            <span [innerHTML]="breadcrumb.title|translate"></span>
          }
        </li>
      }
    </ol>
  </div>
</nav>
